// Served from frontend/public -> available at the site root in dev and prod.
const LOGO = '/gorilla-fitness-logo.png';

export function BrandHeader({ siteUrl }: { siteUrl?: string }) {
  const img = <img src={LOGO} alt="Gorilla Fitness" />;
  return (
    <header className="brand-header">
      {siteUrl ? (
        <a href={siteUrl} target="_blank" rel="noreferrer">
          {img}
        </a>
      ) : (
        img
      )}
    </header>
  );
}
